import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'src/ui/library/Grid/Grid';
import intl from 'react-intl-universal';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { SI_ADDINITIATION_VIEWTYPES, SI_INITIATION_TYPES } from 'src/constants/constants';
import ChooseInitiationContainer from '../containers/ChooseInitiationContainer';
import AddApplicantContainer from '../containers/AddApplicantContainer';
import DynamicContentContainer from '../containers/DynamicContentContainer';
import ActionsBarPres from './ActionsBarPres';
import MenuPres from './MenuPres';

export default function ServiceAddPres({
  showModal,
  toggleModal,
  menu,
  viewType,
  initiationType,
  percentProgress,
  currentMenuPage,
  isNextDisabled,
  isMenuVisible,
  isSubmitDisabled,
  isDraftDisabled,
  isCorpClient,
  onSaveDraft,
  onCancel,
  onSubmit,
  onNextPage,
  onPrevPage,
  changeMenuPage,
  isSubmitting,
}) {
  return (
    <React.Fragment>
      {showModal && (
        <ConfirmDialog
          open
          title={intl.get('serviceInit.addInit.actionBar.pleaseConfirm')}
          cancelText={intl.get('serviceInit.addInit.actionBar.cancel')}
          confirmText={intl.get('serviceInit.addInit.actionBar.continue')}
          onCancel={onCancel}
          onConfirm={toggleModal.bind(null, false)}>
          <span>{intl.get('serviceInit.addInit.actionBar.areYouSure')}</span>
        </ConfirmDialog>
      )}
      <section className="ssi-add-initiation margin-content">
        <Grid container spacing={0}>
          <Grid item xs={9}>
            <div className="ssi-add-inner">
              {viewType === SI_ADDINITIATION_VIEWTYPES.SELECT_SERVICETYPE && <ChooseInitiationContainer isCorpClient={isCorpClient} />}
              {viewType === SI_ADDINITIATION_VIEWTYPES.ADD_APPLICANT && <AddApplicantContainer />}
              {viewType === SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT && (
                <DynamicContentContainer key={currentMenuPage} currentPage={menu[currentMenuPage]} />
              )}
            </div>
          </Grid>
          <Grid item xs={3}>
            <MenuPres menu={menu} currentMenuPage={currentMenuPage} changeMenuPage={changeMenuPage} isNextDisabled={isNextDisabled} />
          </Grid>
        </Grid>
      </section>
      <ActionsBarPres
        percentProgress={percentProgress}
        isNextDisabled={isNextDisabled}
        isFirstPage={currentMenuPage === 0}
        isDraftVisible={initiationType !== SI_INITIATION_TYPES.BATCH_INITIATION}
        isSubmitDisabled={isSubmitDisabled}
        isDraftDisabled={isDraftDisabled}
        isLastPage={viewType === SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT && currentMenuPage === menu.length - 1}
        onSaveDraft={onSaveDraft}
        onCancel={toggleModal.bind(null, true)}
        onSubmit={onSubmit}
        onNextPage={onNextPage}
        onPrevPage={onPrevPage}
        isSubmitting={isSubmitting}
      />
    </React.Fragment>
  );
}

ServiceAddPres.propTypes = {
  showModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  menu: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  percentProgress: PropTypes.number.isRequired,
  currentMenuPage: PropTypes.number.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
  isMenuVisible: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isDraftDisabled: PropTypes.bool.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  changeMenuPage: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};
